import _ from 'lodash';

export default (store) => next => action => {
    const state = store.getState();
    window.ensighten = window.ensighten || {};
    window.ensighten.appStatus = _.get(state, 'serverData.decisionModel.applicationResponse', '');
    window.ensighten.buyerId = _.get(state, 'serverData.buyerId') || _.get(state, 'serverData.decisionModel.buyerId', '');
    window.ensighten.page = _.get(state, 'router.location.pathname', '');
    return next(action);
};
